import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicFormComponent } from '../../common/dynamic-form/dynamic-form.component';

@Component({
  selector: 'app-editor-settings-modal',
  standalone: true,
  imports: [DynamicFormComponent, CommonModule],
  templateUrl: './editor-settings-modal.component.html',
  styleUrl: './editor-settings-modal.component.scss'
})
export class EditorSettingsModalComponent {
 activeModal = inject(NgbActiveModal);
  dynamicForm: any = new FormGroup({});
  isActive:boolean = false;
  selectedDevice: any = null;

  @Input() configs: any = { 
  };

  onFormChange(event: any) {
    // Check if agent field changed (for device selection)
    if (event.field?.key === 'agent') {
      // Find the agent field from the configs
      const agentField = this.configs.fields?.find((f: any) => f.key === 'agent');
      if (agentField?.options) {
        // Recursively search through nested options to find the selected device
        this.selectedDevice = this.findDeviceInOptions(agentField.options[0]?.options, event.value);
      }
    } else {
      this.selectedDevice = null;
    }
  }

  private findDeviceInOptions(options: any[], value: string): any {
    for (const option of options) {
      // Check if this option has the matching value
      if (option.value === value) {
        return option;
      }
      // If this option has nested options, search recursively
      if (option.options && Array.isArray(option.options)) {
        const found = this.findDeviceInOptions(option.options, value);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  save() {
    if (this.dynamicForm.valid) {
      this.activeModal.close({ value: this.dynamicForm.value });
    }
  }

  getDataKeys(): string[] {
    return Object.keys(this.configs.data || {});
  }

  formatLabel(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  }

  getDeviceKeys(): string[] {
    const allowedKeys = ['name', 'deviceType', 'platform', 'environment', 'platformVersion'];
    return Object.keys(this.selectedDevice || {}).filter(key => allowedKeys.includes(key));
  }

  getPlatformIcon(platform: string): string | null {
    if (!platform) return null;
    const platformLower = platform.toLowerCase();
    if (platformLower === 'android') {
      return 'assets/images/virtusa-icons/android.svg';
    } else if (platformLower === 'ios') {
      return 'assets/images/virtusa-icons/ios.svg';
    }
    return null;
  }

}
